import React from "react";
import bg_video from "../../dist/img/Flowdia_Q_BG_movie.mov";
import { useLocation, Link } from "react-router-dom";
const Question12 = ({ deleteStep , addStep, pointsHandler }) => {
  const answerHandler = (option) => {
    addStep();
    pointsHandler(option);
  };
  return (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline muted>
        <source src={bg_video} type="video/mp4"></source>
      </video>
     
      <section className="c-question__progress">
        <dl>
          <dt>QUESTION</dt>
          <dd>
            13 / <span>14</span>
          </dd>
        </dl>
      </section>

      <section className="c-question__content p-question__content p-question__content--3 c-box2">
        <h1 className="c-question__title">ヘアアイロンの使用頻度は？</h1>
        <section
          onClick={() => {
            answerHandler(0);
          }}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>使用していない</p>
        </section>
        <section
          onClick={() => {
            answerHandler(1);
          }}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>週に1～2回</p>
        </section>
        <section
          onClick={() => {
            answerHandler(2);
          }}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>週に3～4回</p>
        </section>
        <section
          onClick={() => {
            answerHandler(3);
          }}
          className="c-question__option p-question__option p-question__option--4"
        >
          <p>週に5回以上</p>
        </section>
        <Link style ={{  margin: "25px auto"}} onClick={() => deleteStep()}  className="c-question__btn2 p-output__btn--v2">
          BACK
        </Link>
      </section>
    </section>
  );
};

export default Question12;
